import { createContext } from 'react'

export const HeaderActionsContext = createContext({
	setHeaderActions: () => {},
	setHeaderLeading: () => {},
})
